import React, { useState } from 'react';
import { Col, Row } from 'antd';
import { DownOutlined, UpOutlined, EyeOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';

type CreditReportSource = {
	label: string;
	urls: string[];
};

export const CREDIT_REPORT_SOURCES: CreditReportSource[] = [
	{
		label: 'Alemania – Komplette SCHUFA-Auskunft',
		urls: ['https://www.meineschufa.de/index.php?site=7']
	},
	{ label: 'Arabia Saudí – The Saudi Credit Bureau (SIMAH)', urls: ['www.simah.com'] },
	{ label: 'Argentina – Equifax VERAZ', urls: ['https://online.org.veraz.com.ar/'] },
	{ label: 'Australia – Equifax', urls: ['https://www.equifax.com.au/personal/'] },
	{
		label: 'Australia – Experian',
		urls: ['https://www.experian.com.au/consumer/order-credit-report']
	},
	{ label: 'Austria – KSV (KreditSchutzVerband von 1870)', urls: ['https://www.ksv.at'] },
	{ label: 'Bélgica – NBB (Banque Nationale de Belgique)', urls: ['https://www.nbb.be/'] },
	{ label: 'Brasil – Boavista Equifax', urls: ['https://www.boavistaservicos.com.br/'] },
	{ label: 'Brasil – Serasa Experian', urls: ['https://www.serasa.com.br/'] },
	{
		label: 'Bulgaria – Bulgarian National Bank',
		urls: ['https://www.bnb.bg/RegistersAndServices/RSCreditRegister/index.htm']
	},
	{ label: 'Canadá – Equifax', urls: ['www.equifax.com/EFX_Canada/'] },
	{ label: 'Canadá – TransUnion', urls: ['www.tuc.ca'] },
	{ label: 'China – Credit Reference Center', urls: ['http://www.pbccrc.org.cn/'] },
	{
		label: 'Corea del Sur – National Information & Credit Evaluation',
		urls: ['http://www.kisinfo.com/']
	},
	{
		label: 'Dinamarca – RKI Kredit Information A/S (Experian Denmark)',
		urls: ['www.experian.dk/']
	},
	{ label: 'Dubái – AECB (Al Etihad Credit Bureau)', urls: ['https://etihadbureau.ae/'] },
	{
		label: 'Eslovaquia – CRIF (Slovak Credit Bureau)',
		urls: ['https://moje-financie.sk/en/credit-report']
	},
	{ label: 'Eslovenia – Sisbon (The Bank Association of Slovenia)', urls: ['http://sisbon.si/sl'] },
	{ label: 'Estados Unidos – Equifax', urls: ['www.equifax.com/'] },
	{ label: 'Estados Unidos – Experian', urls: ['https://www.experian.com/'] },
	{ label: 'Estonia – Krediidiinfo AS (Experian)', urls: ['www.krediidiinfo.ee'] },
	{ label: 'Finlandia – Suomen Asiakastieto Oy', urls: ['www.asiakastieto.fi/omatieto/fi'] },
	{ label: 'Finlandia – Suomen Online Palvelut Oy', urls: ['https://www.luottotietohaku.fi'] },
	{ label: 'Finlandia – Bisnode Finland', urls: ['https://finland.bisnode.fi'] },
	{
		label: 'Francia – FICP (Banque de France)',
		urls: ['https://accueil.banque-france.fr/uti/#/accueil']
	},
	{
		label: 'Francia – Service Public (FICP, trámite)',
		urls: ['https://www.service-public.fr/particuliers/vosdroits/F17608']
	},
	{ label: 'Ghana – XDS Ghana Limited', urls: ['http://www.xdscreditbureau.com/'] },
	{ label: 'Grecia – Teiresias SA (griego)', urls: ['https://www.tiresias.gr/el/'] },
	{ label: 'Grecia – Teiresias SA (inglés)', urls: ['https://www.tiresias.gr/en'] },
	{
		label: 'Hong Kong, China – TransUnion Information Services Limited',
		urls: ['http://www.transunion.hk/']
	},
	{ label: 'Hungría – BISZ Central Credit Information Plc.', urls: ['www.bisz.hu'] },
	{ label: 'Islandia – CreditInfo', urls: ['http://creditinfo.is'] },
	{ label: 'India – Experian India', urls: ['http://www.experian.in/'] },
	{ label: 'India – Highmark Credit Information Services', urls: ['http://www.myhighmark.com/'] },
	{ label: 'India – Credit Information Bureau (India) Ltd (CIBIL)', urls: ['www.cibil.com'] },
	{
		label: 'India – Equifax Credit Information Services Pvt Ltd (ECIS)',
		urls: ['www.equifax.com']
	},
	{ label: 'Indonesia – Biro Kredit Indonesia', urls: ['www.birokredit.com'] },
	{
		label: 'Irlanda – Central Bank of Ireland (Credit Report)',
		urls: ['www.centralcreditregister.ie']
	},
	{
		label: "Italia – CRIF (Centrale Rischi d'Intermediazione Finanziaria)",
		urls: ['https://www.crif.it']
	},
	{ label: 'Italia – Mettinconto', urls: ['http://www.mistercredit.it'] },
	{ label: 'Japón – Credit Information Center Corporation', urls: ['www.cic.co.jp'] },
	{ label: 'Kenya – TransUnion Kenya', urls: ['www.transunionitc.co.za'] },
	{
		label: 'Letonia – KIB (Kredītu Informācijas Biroju)',
		urls: ['https://www.manakreditvesture.lv/']
	},
	{
		label: 'Lithuania – Lietuvos Bankas paskolų rizikos duomenų bazė',
		urls: ['https://www.lb.lt/lt/paskolu-rizikos-duomenu-baze']
	},
	{
		label: 'Malta – CCR (Central Credit Register, Central Bank of Malta)',
		urls: ['https://www.centralbankmalta.org/CCR']
	},
	{ label: 'México – Buró de Crédito (TransUnion)', urls: ['www.burodecredito.com.mx'] },
	{ label: 'Marruecos – Experian Morocco', urls: ['http://www.experian.co.ma/'] },
	{ label: 'Noruega – Experian Norway', urls: ['www.experian.no/'] },
	{
		label: 'Noruega – Gjeldsregisteret',
		urls: ['https://www.gjeldsregisteret.com/pages/innsyn-i-egne-opplysninger']
	},
	{ label: 'Noruega – Norsk Gjeldsinformasjon', urls: ['https://www.norskgjeld.no/'] },
	{
		label: 'Nueva Zelanda – Equifax',
		urls: ['https://www.equifax.com.au/personal/products/credit-and-identity-products']
	},
	{ label: 'Nueva Zelanda – Illion', urls: ['https://www.creditcheck.illion.co.nz/'] },
	{ label: 'Omán – NBCI (National Bureau of Commercial Information)', urls: ['www.nbci.co.om'] },
	{ label: 'Países Bajos – BKR (Bureau Krediet Registratie)', urls: ['http://www.bkr.nl/'] },
	{ label: 'Polonia – Biuro Informacji Kredytowej S.A.', urls: ['www.bik.pl'] },
	{
		label: 'Portugal – Mapa de Responsabilidades de Crédito (Banco de Portugal)',
		urls: ['https://www.bportugal.pt/area-cidadao/formulario/227']
	},
	{ label: 'Puerto Rico – TransUnion De Puerto Rico', urls: ['www.transunion.com'] },
	{ label: 'Reino Unido – Experian', urls: ['www.experian.co.uk'] },
	{ label: 'Reino Unido – Equifax UK', urls: ['www.equifax.co.uk/'] },
	{
		label: 'República Checa – CBCB (Czech Banking Credit Bureau)',
		urls: ['https://kolikmam.cz/vypis-z-registru']
	},
	{ label: 'Rumania – Biroul de Credit S.A.', urls: ['www.birouldecredit.ro'] },
	{ label: 'Rumania – CreditInfo Romania', urls: ['www.creditinfo.ro/'] },
	{ label: 'Rusia – NBKI (National Bureau of Credit Histories)', urls: ['http://www.nbki.ru/'] },
	{ label: 'Singapur – Credit Bureau (Singapore) Pte Ltd.', urls: ['www.creditbureau.com.sg'] },
	{ label: 'Singapur – DB Information Group', urls: ['http://www.dpgroup.com.sg/'] },
	{ label: 'Sudáfrica – Experian', urls: ['https://www.mycreditexpert.co.za/'] },
	{
		label: 'Sudáfrica – TransUnion',
		urls: ['https://www.transunion.co.za/product/credit-report-and-score']
	},
	{ label: 'Suecia – UC "min-upplysning"', urls: ['https://www.minuc.se/min-upplysning'] },
	{ label: 'Suiza – ZEK (Zentralstelle für Kreditinformation)', urls: ['www.zek.ch'] },
	{ label: 'Turquía – KKB (Kredi Kayit Bürosu A.S.)', urls: ['https://www.kkb.com.tr/'] },
	{
		label: 'Ucrania – CreditInfo Ukraine',
		urls: ['http://www.creditinfo.com/', 'https://credithistory.com.ua/']
	},
	{
		label: 'Ucrania – FCBU (First Credit Bureau of Ukraine)',
		urls: ['http://www.pvbki.com/en/', 'www.ubki.ua']
	}
];

const normalizeUrl = (url: string) => (url.startsWith('http') ? url : `https://${url}`);

type Props = {
	t: any;
};

const CreditReportSources = ({ t }: Props) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Row style={{ marginTop: 24 }}>
				<Col>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							cursor: 'pointer',
							color: '#212121',
							fontSize: isMobileOnly ? 12 : 14,
							fontWeight: 500
						}}
						onClick={() => setOpen(!open)}>
						<EyeOutlined style={{ marginRight: 6 }} />
						<span
							dangerouslySetInnerHTML={{
								__html: t('doc.doubtsHowFindCreditReportTitle')
							}}
						/>
						{open ? (
							<UpOutlined style={{ marginLeft: 8, fontSize: 12 }} />
						) : (
							<DownOutlined style={{ marginLeft: 8, fontSize: 12 }} />
						)}
					</div>
				</Col>
			</Row>
			{open && (
				<Row style={{ marginTop: 8 }}>
					<Col span={24}>
						<ul
							style={{
								margin: 0,
								paddingLeft: 20,
								maxHeight: 320,
								overflowY: 'auto',
								color: '#757575',
								fontSize: 12,
								lineHeight: '16px'
							}}>
							{CREDIT_REPORT_SOURCES.map((source) => (
								<li key={source.label} style={{ marginBottom: 4 }}>
									{source.label}:{' '}
									{source.urls.map((url, index) => (
										<span key={url}>
											{index > 0 && ' y '}
											<a
												href={normalizeUrl(url)}
												target="_blank"
												rel="noopener noreferrer"
												style={{ color: '#006DFF' }}>
												{url}
											</a>
										</span>
									))}
								</li>
							))}
						</ul>
					</Col>
				</Row>
			)}
		</>
	);
};

export default CreditReportSources;
